import request from 'superagent';

export default {

    getOnlineStatus(context, { lastSeenTimesUrl }, done) {
        const onlineStatuses = {};
        request
            .get(lastSeenTimesUrl)
            .end((err, res) => {
                if (!err) {
                    const times = res.body.times;

                    // FIXME: Use Object.keys
                    for (const id in times) { // eslint-disable-line
                        const now = new Date();
                        onlineStatuses[id] = {
                            isOnline: new Date(times[id]) >= now.setMinutes(now.getMinutes() - 5),
                            lastSeenTime: times[id],
                        };
                    }
                    context.dispatch('ONLINE_STATUS_SUCCESS', onlineStatuses);
                }
                done();
            });
    },
};



// WEBPACK FOOTER //
// ./src/js/actions/OnlineStatusActionCreators.js